import {AfterViewInit, Component, OnInit, ViewChild} from '@angular/core';
import {IExgEvent} from '../../misc/interfaces/IExgEvent';
import {ExcCoreModule, ExcTranslation} from 'exc-core-v2';
import {ExgApplicationEventEmitter} from '../../misc/classes/ExgApplicationEventEmitter';
import {ExgApplicationTabService} from 'exc-tab-v2';
import {ExcRestService, IExcDataFilter, IExcDataPaging, IExcDataSort} from 'exc-rest-v2';
import {EnumerationService} from '../../services/enumeration.service';
import {IExcMetaInfo} from 'exc-rest-v2/lib/interfaces/IExcMetaInfo';
import {ExgDataListComponent, ExgModalService} from 'exc-controls-v2';
import {ApplicationService} from '../../services/application.service';
import {DispositionMap2Component} from '../disposition-map2/disposition-map2.component';
import {ExcSecurityService} from 'exc-security-v2';
import {ExgFilterComponent} from '../../misc/exg-filter/exg-filter.component';

@Component({
  selector: 'app-disposition-list',
  templateUrl: './disposition-list.component.html',
  styles: []
})
export class DispositionListComponent extends ExcTranslation implements AfterViewInit, OnInit, IExgEvent {
  @ViewChild('VCSummaryDataFilterControl', {read: ExgFilterComponent}) VCSummaryDataFilterControl!: ExgFilterComponent;
  @ViewChild('SOlist', {read: ExgDataListComponent}) VCSOlist!: ExgDataListComponent;
  @ViewChild(DispositionMap2Component) VCDispoMap2!: DispositionMap2Component;

  Events = new ExgApplicationEventEmitter();

  assignList =  {
    data: [] as any,
    // vorgangUMultiAssign: (): void => {
    //   const assignList = this.assignList.data;
    //   if (assignList.length >= 0) {
    //     this.excRestService.put(
    //       this.excRestService.computeUrl('TaskU_MultiAssign')
    //       , {assignList, test: 1}
    //     ).subscribe((ret) => {
    //       this.assignList.data = [];
    //       this.modal.showToast(
    //         this.getRessource('assigned')
    //         , 'md-toast bg-green', 'fa-duotone fa-arrows-down-to-people');
    //       this.SummaryData.reloadData();
    //     });
    //   }
    // }
  };
  SummaryData = {
    isLoading: true,
    searchValue: '',
    multiRoute: false,
    data: {} as any,
    schadenortData: {} as any,
    selected: [] as any[],
    selectedObjects: [] as any[],
    state: 1,
    uiFilterEnumGroup: [
      {enmName: 'VorgangTyp', enmField: 'vorg_enmIdent_VorgangTyp', enmTable: 'Vorgang', defaultValues: [1, 16, 2, 14, 3, 23, 24]},
      {enmName: 'Schadenart', enmField: 'aue_enmIdent_SchadenArt', enmTable: 'AuftragE_EIS', enmAlt: false, enmAltTT: true}
    ],
    uiFilterSearchFields: [
      {tableField: 'adrPlz', table: 'Adresse', groupCaption: 'Schadenort'},
      {tableField: 'adrOrt', table: 'Adresse', groupCaption: 'Schadenort'},
      {tableField: 'adrStr', table: 'Adresse', groupCaption: 'Schadenort'},
      {tableField: 'aueVersicherungsnehmer', table: 'AuftragE_EIS', groupCaption: 'Schaden'},
      {tableField: 'aueSchadenOrt', table: 'AuftragE_EIS', groupCaption: 'Schaden'},
      {tableField: 'vorgNr', table: 'Vorgang'},
      {tableField: 'Bearbeiter', table: 'Vorgang'},
      {tableField: 'Bearbeiter_Handy', table: 'Vorgang'},
      {tableField: 'vorgLCU', table: 'All', groupCaption: 'Vorgang'},
      {tableField: 'vorgLCD', table: 'All', groupCaption: 'Vorgang'},
      {groupCaption: 'Vorgang', table: 'All', tableField: 'vorgCKD'},
      {table: 'Vorgang', tableField: 'vorgFrist'},
      {tableField: 'auAuftraggeberShort', table: 'Auftrag', repColumn: 'au_oeID_Auftraggeber'},
      {tableField: 'auAnsprechpartner', table: 'Auftrag'},
    ],
    uiSortFieldGroup: [
      {fieldGroup: 'Schadenort', fieldTable: 'Adresse', fieldName: 'adrPlz'},
      {fieldGroup: 'Schadenort', fieldTable: 'Adresse', fieldName: 'adrOrt'},
      {fieldGroup: 'Vorgang', fieldTable: 'All', fieldName: 'vorgLCD'},
      {fieldGroup: 'Vorgang', fieldTable: 'All', fieldName: 'vorgCRD'},
      {fieldGroup: 'Vorgang', fieldTable: 'All', fieldName: 'vorgCKD'},
      {fieldGroup: 'Vorgang', fieldTable: 'Vorgang', fieldName: 'vorgFrist'},
      {fieldGroup: 'Auftrag', fieldTable: 'AuftragE_EIS', fieldName: 'aueSchadenDatum'},
      {fieldGroup: 'Auftrag', fieldTable: 'AuftragE_EIS', fieldName: 'aueAuftragsdatum'},
      {fieldGroup: 'Auftrag', fieldTable: 'AuftragE_EIS', fieldName: 'aueOrtsterminPlan'},
      {fieldGroup: 'Auftrag', fieldTable: 'AuftragE_EIS', fieldName: 'aueOrtstermin'},
      {fieldGroup: 'Auftrag', fieldTable: 'AuftragE_EIS', fieldName: 'aueOrtstermin2'},
      {fieldGroup: 'Auftrag', fieldTable: 'AuftragE_EIS', fieldName: 'aueSchadenmeldungVU'},
      {fieldGroup: 'Auftrag', fieldTable: 'AuftragE_EIS', fieldName: 'aueFristverlaengerungBis'},
      {fieldGroup: 'Auftrag', fieldTable: 'AuftragE_EIS', fieldName: 'aueZwischenberichtDatum'},
    ],
    uiFilter: [] as any [],
    uiSort: [] as any [],
    uiSortAktiv(): any[] {
      return this.uiSort.filter((sort: any) => sort.uiValue !== 0);
    },
    MetaInfo: {
      dataPaging: {pageNo: 0, pageSize: 25} as IExcDataPaging,
      dataSort: {} as IExcDataSort,
      dataFilter: {} as IExcDataFilter,
    } as IExcMetaInfo,
    paging: {pagingPage: 0, pagingEndRow: 0, pagingPageSize: 25, pagingTotalPages: 0, pagingTotalRows: 0, pagingStartRow: 0},
    changeMultiRoute: (): void => {
      this.SummaryData.selectedObjects = [];
      this.SummaryData.multiRoute = !this.SummaryData.multiRoute;
    },
    rowChange: (index: number) => {
      if (!this.SummaryData.multiRoute) {
        if (!this.SummaryData.selectedObjects.find((sOrt: any) => sOrt === this.SummaryData.schadenortData[index])) {
          this.SummaryData.selectedObjects = [];
          this.SummaryData.selectedObjects.push(this.SummaryData.schadenortData[index]);
        } else {
          this.VCSOlist.selectedRow = -1;
          this.SummaryData.selectedObjects = [];
        }
        this.VCDispoMap2.updateMarkers();
      }
    },
    itemSelect: (index: number) => {
      if (this.SummaryData.selectedObjects.find((sOrt: any) => sOrt === this.SummaryData.schadenortData[index])) {
        this.SummaryData.selectedObjects =
          this.SummaryData.selectedObjects.filter((sOrt: any) => sOrt !== this.SummaryData.schadenortData[index]);
      } else {
        this.SummaryData.selectedObjects.push(this.SummaryData.schadenortData[index]);
      }
      this.VCDispoMap2.updateMarkers();
    },
    search(value: string): void {
      this.searchValue = value;
      this.reloadData();
    },
    pageChanged: (page: number): void => {
      if (this.SummaryData.MetaInfo.dataPaging !== undefined) {
        this.SummaryData.MetaInfo.dataPaging.pageNo = page;
      }
      this.SummaryData.reloadData();
    },
    ready: () => {
      if (this.SummaryData.schadenortData.length === 0) {
        this.SummaryData.state = 2;
      }  else {
        this.SummaryData.state = 0;
      }
      this.SummaryData.isLoading = false;
    },
    loadData: (data: any, paging: any): void => {
      this.SummaryData.data = data;
      this.SummaryData.schadenortData = data.Schadenorte;
      this.SummaryData.paging = paging.Schadenorte;
      if (this.SummaryData.data.DL.length > 0) {
        for (const dlElement of this.SummaryData.data.DL) {
          const temp: any[] = [];
          Object.assign(dlElement, {
            assignedTasks: ExcCoreModule.Array.GetAll(
              this.SummaryData.data.DisponiertSchadenorteDL,
              'vorg_oid_Bearbeiter',
              dlElement.oeID
            )
          });
          Object.assign(dlElement, {
            assignedTasksRegions: [],
            assignedTasksRegionsShort: []
          });
          ExcCoreModule.Array.GetAll(
            this.SummaryData.data.DisponiertSchadenorteDL,
            'vorg_oid_Bearbeiter',
            dlElement.oeID
          ).forEach((task: any) => {
            if (task.adrPlz) {
              // Task PLZ: 2 Stellen
              dlElement.assignedTasksRegions.push(task.adrPlz.slice(0, 2));
              // Task PLZ: Stelle 1
              const region = dlElement.assignedTasksRegionsShort.find(
                (postCode: any) => postCode?.postCode === task.adrPlz.slice(0, 1)
              );
              if (!!region && (task.adrPlz && task.adrPlz.startsWith(region.postCode))) {
                region.count = region.count + 1;
              } else {
                dlElement.assignedTasksRegionsShort.push({ postCode: task.adrPlz.slice(0, 1), count: 1});
              }
            }
          });

          // Sort: assignedTasksRegionsShort
          dlElement.assignedTasksRegionsShort =
            dlElement.assignedTasksRegionsShort
              .sort((dlPostCode1: any, dlPostCode2: any) =>
                dlPostCode1 && dlPostCode2 && dlPostCode1.postCode > dlPostCode2.postCode ? 1 : -1
              );

          // Sort: assignedTasksRegions
          dlElement.assignedTasksRegions =
            ExcCoreModule.Array
              .Distinct(dlElement.assignedTasksRegions)
              .sort((dlPostCode1: string, dlPostCode2: string) => dlPostCode1 > dlPostCode2 ? 1 : -1);
        }
      }
    },
    reloadData: (): void  => {
      this.SummaryData.isLoading = true;
      this.SummaryData.state = 1;
      this.assignList.data = [];

      this.excRestService.get(
        this.excRestService.computeUrl('DispositionSchadenOrtR_List', {
          fts: this.SummaryData.searchValue})
        , {MetaInfo: this.SummaryData.MetaInfo}
      ).subscribe((result) => {
        this.SummaryData.schadenortData = result.data?.Schadenorte;
        this.SummaryData.paging = result.paging?.Schadenorte;
        this.SummaryData.ready();
      });
    },
  };
  worker = {
    all: ['green', 'blue', 'yellow', 'orange', 'red'],
    green: true,
    blue: true,
    yellow: true,
    orange: true,
    red: true
  };

  constructor(
    public appSvc: ApplicationService,
    private exgApplicationTabService: ExgApplicationTabService,
    private excRestService: ExcRestService,
    public enumSvc: EnumerationService,
    private modal: ExgModalService,
    public excSecurity: ExcSecurityService
  ) {
    super();
    this.initEnumerations();
  }

  ngOnInit(): void {
    this.registerEvents();
  }

  ngAfterViewInit(): void {
    console.log(this.SummaryData.uiFilter);
    this.VCSummaryDataFilterControl.ApplyFilter();
    this.loadSummaryData();
  }

  initEnumerations(): void {
    this.SummaryData.uiFilter = this.appSvc.metaInfo.dataFilter(
      this.SummaryData.uiFilterEnumGroup,
      this.SummaryData.uiFilterSearchFields);
    this.SummaryData.uiSort = this.appSvc.metaInfo.dataSort(this.SummaryData.uiSortFieldGroup);
  }

  registerEvents(): void {
    if (this.exgApplicationTabService.StateTab?.Active) {
      ExcCoreModule.Services().GlobalRefresh.subscribe(() => {
        this.SummaryData.reloadData();
      });
    }
  }


  loadSummaryData(): void {
    this.SummaryData.isLoading = true;
    this.SummaryData.state = 1;

    this.excRestService.get(
      this.excRestService.computeUrl('DispositionR_Summary', {})
      , {MetaInfo: this.SummaryData.MetaInfo}
    ).subscribe((result) => {
      this.SummaryData.loadData(result.data, result.paging);
      this.SummaryData.ready();
    });
  }

  onClickOpenTaskCheckview(task: any): void {
    if (this.excSecurity.isFeatured('TASKREAD')) {
      this.appSvc.Task.Workspace.OpenTabV2(task.vorgID);
    }
  }
}
